/**
 * @file footer
 * @author fengfaxia(fengfaxia@baidu.com))
 *  Copyright (c) 2018-07-18 Baidu
 */

import React from 'react';

export default class Footer extends React.Component {
    render() {
        const copyrightTime = (new Date()).getFullYear();
        return (
            <div className="footer">
                ©{copyrightTime} Baidu &nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="https://www.baidu.com/duty/" target="_blank">使用百度前必读</a> &nbsp;&nbsp;|&nbsp;&nbsp;
                <span>京ICP证030173号-21</span>&nbsp;&nbsp;|&nbsp;&nbsp;
                联系我们：<a href="mailto:ext_dwz-help@baidu.com">ext_dwz-help@baidu.com</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="/console/service" target="_blank">服务协议</a>
            </div>
        );
    }
}
